import React from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components

import MDButton from "./MDButton";
import MDSocialButton from "./MDSocialButton";
import MDTypography from "./MDTypography";

export default function RegularButton({ ...props }) {
    const {
        size,
        variant,
        color,
        circular,
        iconOnly,
        children,
        onClick,
        disabled,
        fullWidth,
        mt,
        ...rest
    } = props;

    var coloresbase = [
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ];

    if (color == null || color == "" || coloresbase.includes(color)) {

        return (
            <MDButton {...rest} color={color} size={size} circular={circular} variant={variant} iconOnly={iconOnly} onClick={onClick} disabled={disabled} fullWidth={fullWidth} sx={{ mx: 0.2, mt: mt, my:0.2 }}>
                <MDTypography variant="button" color={color == "light" ? "dark" : "white"}>
                    {children}
                </MDTypography>                
            </MDButton>
        );
    }
    else {
        return (<MDSocialButton {...rest} color={color} size={size} circular={circular} variant={variant} iconOnly={iconOnly} onClick={onClick} disabled={disabled} fullWidth={fullWidth} sx={{ mx: 0.2, my: 0.2 }}>
            <MDTypography variant="button" color="white">
                {children}
            </MDTypography>
        </MDSocialButton>)
    }
}


RegularButton.propTypes = {
    size: PropTypes.oneOf(["small", "medium", "large"]),
    variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
    color: PropTypes.oneOf([
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    circular: PropTypes.bool,
    iconOnly: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.object,
    disabled: PropTypes.bool
}


/*
function RegularButton({ ...props }) {
  const {
    classes,
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block,
    link,
    iconOnly,
    className,
    muiClasses,
    ...rest
  } = props;
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    [classes[color]]: color,
    [classes.round]: round,
    [classes.fullWidth]: fullWidth,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.iconOnly]: iconOnly,
    [className]: className
  });
  return (
    <Button {...rest} classes={muiClasses} className={btnClasses}>
      {children}
    </Button>
  );
}

RegularButton.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "twitter",
    "facebook",
    "google",
    "linkedin",
    "pinterest",
    "youtube",
    "tumblr",
    "github",
    "behance",
    "dribbble",
    "reddit",
    "transparent"
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  iconOnly: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object
};

export default withStyles(buttonStyle)(RegularButton);*/
